<div
  class="data-table-main-container"
  [class.overlay-active]="context.applicationViewType === 'overlay'"
>
  @if (context.applicationViewType === 'overlay') {
  <div class="new-application-overlay">
    <router-outlet></router-outlet>
  </div>
  } @if(dataTableDetails.showRelateToPermitView === true){
  <!-- Updated by Amisha on 2026-09-21.
       Reason: identify the Relate to Permit layer so mobile can place it above the portaled inline expansion. -->
  <div class="new-application-overlay relate-to-permit-overlay">
    <wm-relate-to-permit-card></wm-relate-to-permit-card>
  </div>
  }

  <!-- Added by amisha on 2026-06-01 to enforce Janus-specific visible-column rules in the shared table menu.
         Reason: this screen should allow at most 7 visible data columns and warn on the 8th selection. -->
  <!-- Added by amisha on 2026-08-24 to enable configured fixed widths for the Janus applications table.
         Reason: sorting Current Activity or another field must not shift columns when returned values change length. -->
  <wm-common-table
    [isLoading]="dataTableDetails.fetchingHeadersAndRows"
    [errorMessage]="dataTableDetails.fetchError"
    [fixedColumnWidths]="true"
    [loadingData]="dataTableDetails.fetchingRows"
    [columns]="dataTableDetails.headers"
    [data]="dataTableDetails.rows"
    [tableType]="'Staff'"
    [pageSizeStorageKey]="'application'"
    [serverSidePagination]="true"
    [totalPages]="dataTableDetails.totalNoOfPages"
    [currentPage]="dataTableDetails.pageNumber - 1"
    [pageSize]="dataTableDetails.maxRows"
    [totalRecords]="totalRecords"
    [selectedRecords]="dataTableDetails.selectedIds.length"
    [showRowsPerPage]="true"
    [showTotalRecords]="true"
    (rowsPerPageChange)="onRowsPerPageChange($event)"
    (pageChange)="onPageChange($event)"
    expansionMode="inline"
    expandOn="cell"
    [expansionTemplate]="expansionTemplate"
    (rowClick)="setExpandedRow($event)"
    [expandedRow]="dataTableDetails.expandedRow"
    (sortChanged)="onSortChanged($event)"
    [clientSortState]="{
      active: dataTableDetails.sortBy,
      direction: dataTableDetails.sortMode
    }"
    [onlySimpleClose]="true"
    [displayedColumns]="dataTableDetails.columnsToDisplayed"
    [maxVisibleColumns]="7"
    [maxVisibleColumnsMessage]="'You can only show 7 columns at once.'"
    (visibleColumnLimitReached)="onVisibleColumnLimitReached($event)"
    (displayedColumnsChange)="toggleColumnsHideShow($event)"
    [fixedPagination]="
      context.applicationViewType === 'overlay' ||
      dataTableDetails.showRelateToPermitView === true
        ? false
        : true
    "
    [enableTableScroll]="
      context.applicationViewType === 'overlay' ||
      dataTableDetails.showRelateToPermitView === true
        ? false
        : true
    "
    (rowCheckboxClick)="onSpecificRowCheckboxClick($event)"
    (headerCheckboxClick)="onHeaderCheckboxClick($event)"
    [updateColumnsOnClose]="true"
    [showRetryButton]="false"
    [showErrorIcon]="true"
  ></wm-common-table>
  <wm-common-confirmation-modal
    [data]="columnLimitModalData"
    (onOkClick)="columnLimitModalData.open = false"
  >
  </wm-common-confirmation-modal>
</div>
<ng-template #applicationNoTemplate let-row>
  <div class="app-number-cell">
    <a
      [routerLink]="[]"
      [queryParams]="{ id: row.id }"
      queryParamsHandling="merge"
      [ngClass]="
        row.userIsResponsibleForACurrentActivity
          ? 'app-number-link-responsible'
          : 'janus-anchor'
      "
      (click)="onApplicationNumberClick($event, row)"
      >{{ row['App #'] }}</a
    >
    <span
      *ngIf="row.userIsResponsibleForACurrentActivity"
      class="app-number-responsible-badge"
      title="You are a member of a Role responsible for a current activity on this application"
      aria-label="You are responsible for a current activity on this application"
    ></span>
  </div>
</ng-template>

<ng-template #attachmentsTemplate let-row>
  <mat-icon
    aria-hidden="false"
    [matBadge]="row.documentsToReview"
    matBadgePosition="above after"
    matBadgeOverlap="true"
    matBadgeOffset="10px 10px"
    [matBadgeHidden]="!(+row.documentsToReview > 0)"
    style="width: 20px;height: 20px;font-size: 20px;"
    (click)="handleIconClick($event, row, 'attachment')"
    [style.color]="getAttachmentColor(row)"
    [style.cursor]="'pointer'"
  >
    attach_file
  </mat-icon>
</ng-template>
<ng-template #chatTemplate let-row>
  <mat-icon
    aria-hidden="false"
    [matBadge]="row.messages"
    matBadgePosition="above after"
    matBadgeOverlap="true"
    matBadgeOffset="10px 10px"
    [matBadgeHidden]="row.messages === '0'"
    style="width: 20px;height: 20px;font-size: 20px;"
    [style.color]="getChatColor(row)"
    [style.cursor]="'pointer'"
    (click)="handleIconClick($event, row, 'chat')"
  >
    chat_bubble_outline
  </mat-icon>
</ng-template>
<ng-template #notesTemplate let-row>
  <mat-icon
    aria-hidden="false"
    [matBadge]="row.unreadNotes"
    matBadgePosition="above after"
    matBadgeOverlap="true"
    matBadgeOffset="10px 10px"
    [matBadgeHidden]="!(+row.unreadNotes > 0)"
    style="width: 20px;height: 20px;font-size: 20px;"
    (click)="handleIconClick($event, row, 'note')"
    [style.color]="getNotesColor(row)"
    [style.cursor]="'pointer'"
  >
    note_alt
  </mat-icon>
</ng-template>
<ng-template #signOffTemplate let-row>
  <div
    (click)="handleIconClick($event, row, 'status')"
    [matTooltip]="row.signOff?.tooltip"
  >
    @if (getSignOffColor(row) === 'grey') {
    <div class="not-applicable">
      <wm-common-text [data]="{ text: 'N/A' }"></wm-common-text>
    </div>
    }@else if (getSignOffColor(row) === 'red') {
    <mat-icon aria-hidden="false" class="icon-column-body error-icon-color">{{
      errorIcon
    }}</mat-icon>
    }@else if(getSignOffColor(row) === 'green'){
    <mat-icon aria-hidden="false" class="icon-column-body check-icon-color"
      >check_circle</mat-icon
    >
    }@else if(getSignOffColor(row) === 'orange'){
    <mat-icon aria-hidden="false" class="icon-column-body warning-icon-color"
      >warning_amber</mat-icon
    >
    }
  </div>
</ng-template>
<ng-template #feesTemplate let-row>
  <div
    (click)="handleIconClick($event, row, 'status')"
    [matTooltip]="row.fees?.tooltip"
  >
    @if (getFeesColor(row) === 'grey') {
    <div class="not-applicable">
      <wm-common-text [data]="{ text: 'N/A' }"></wm-common-text>
    </div>
    }@else if (getFeesColor(row) === 'red') {
    <mat-icon aria-hidden="false" class="icon-column-body error-icon-color">{{
      errorIcon
    }}</mat-icon>
    }@else if(getFeesColor(row) === 'green'){
    <mat-icon aria-hidden="false" class="icon-column-body check-icon-color"
      >check_circle</mat-icon
    >
    }@else if(getFeesColor(row) === 'orange'){
    <mat-icon aria-hidden="false" class="icon-column-body warning-icon-color"
      >warning_amber</mat-icon
    >
    }
  </div>
</ng-template>
<ng-template #inspectionsTemplate let-row>
  <div
    (click)="handleIconClick($event, row, 'status')"
    [matTooltip]="row.inspections?.tooltip"
  >
    @if (getInspectionsColor(row) === 'grey') {
    <div class="not-applicable">
      <wm-common-text [data]="{ text: 'N/A' }"></wm-common-text>
    </div>
    }@else if (getInspectionsColor(row) === 'red') {
    <mat-icon aria-hidden="false" class="icon-column-body error-icon-color">{{
      errorIcon
    }}</mat-icon>
    }@else if(getInspectionsColor(row) === 'green'){
    <mat-icon aria-hidden="false" class="icon-column-body check-icon-color"
      >check_circle</mat-icon
    >
    }@else if(getInspectionsColor(row) === 'orange'){
    <mat-icon aria-hidden="false" class="icon-column-body warning-icon-color"
      >warning_amber</mat-icon
    >
    }
  </div>
</ng-template>

<ng-template #expansionTemplate let-row>
  <div class="inline-application-container">
    <div class="top-space"></div>
    <div class="inline-body-container">
      <div class="left-space"></div>
      <div class="main-inline-body-container">
        <!-- Added by Amisha on 2026-09-16.
             Reason: match the approved staff mobile expansion with application details
             followed by the existing actionable status icons. -->
        <!-- Updated by Amisha on 2026-09-21.
             Reason: the full Application View already contains its own application information,
             so do not repeat the mobile details card and shortcut icons above it. -->
        @if (!isFullApplicationViewActive) {
        <section class="mobile-application-summary" aria-label="Application details">
          <div class="mobile-application-details-card">
            <div class="mobile-application-details-heading">Application Details</div>
            <div class="mobile-application-details-grid">
              <div><span>App Type:</span> {{ getMobileRowValue(row, 'App Type', 'Application Type') }}</div>
              <div><span>Site:</span> {{ getMobileRowValue(row, 'Site', 'Site Address', 'Address') }}</div>
              <div><span>Issue Date:</span> {{ getMobileRowValue(row, 'Issue Date', 'App Date', 'Application Date') }}</div>
              <div><span>Applicant:</span> {{ getMobileRowValue(row, 'Applicant', 'Applicant Name') }}</div>
              <div><span>Owner:</span> {{ getMobileRowValue(row, 'Owner', 'Owner Name', 'Parcel Owner') }}</div>
              <div><span>Permit #:</span> {{ getMobileRowValue(row, 'Permit #', 'Permit Number') }}</div>
              <div><span>Status #:</span> {{ getMobileRowValue(row, 'Status') }}</div>
            </div>
          </div>

          <div class="mobile-application-icon-row" aria-label="Application shortcuts">
            <button type="button" aria-label="Attachments">
              <ng-container *ngTemplateOutlet="attachmentsTemplate; context: { $implicit: row }"></ng-container>
            </button>
            <button type="button" aria-label="Chat">
              <ng-container *ngTemplateOutlet="chatTemplate; context: { $implicit: row }"></ng-container>
            </button>
            <button type="button" aria-label="Notes">
              <ng-container *ngTemplateOutlet="notesTemplate; context: { $implicit: row }"></ng-container>
            </button>
            <button type="button" aria-label="Sign off status">
              <ng-container *ngTemplateOutlet="signOffTemplate; context: { $implicit: row }"></ng-container>
            </button>
            <button type="button" aria-label="Fee status">
              <ng-container *ngTemplateOutlet="feesTemplate; context: { $implicit: row }"></ng-container>
            </button>
            <button type="button" aria-label="Inspection status">
              <ng-container *ngTemplateOutlet="inspectionsTemplate; context: { $implicit: row }"></ng-container>
            </button>
          </div>
        </section>
        }

        <app-inline-applications-card
          [applicationId]="row.id"
          [applicationDate]="row[dataTableKeys.appDate]"
          [applicationStatus]="row[dataTableKeys.status]"
          [onlyAttachments]="dataTableDetails.showOnlyAttachments"
          [onlyNotes]="dataTableDetails.showOnlyNotes"
          (notesChanged)="onInlineNotesChanged($event)"
          (attachmentChanged)="onInlineAttachmentsChanged($event)"
        ></app-inline-applications-card>
      </div>
      <div class="right-space"></div>
    </div>
    <div class="bottom-space"></div>
  </div>
</ng-template>
<!-- Added by amisha on 10-02-2026 for chat window -->
<!-- Added by Amisha on 2026-07-02.
     Reason: pass the resolved department name into chat so the Outlook mail content uses the correct department label. -->
<!-- Added by Amisha on 2026-09-09.
     Reason: pass staff attempts to open a different chat into the shared visual attention behavior. -->
<!-- Updated by Amisha on 2026-09-22.
     Reason: only staff chat opened from this inline table should cover the expansion header on mobile. -->
<wm-chat-window
  *ngIf="showChat && chatContext"
  [applicationId]="chatContext.applicationId"
  [applicationType]="chatContext.applicationType"
  [departmentName]="chatContext.departmentName"
  [siteAddress]="chatContext.siteAddress"
  [internalMessageId]="chatContext.internalMessageId"
  [attentionTrigger]="chatAttentionTrigger"
  [isStaff]="true"
  [fullViewportMobile]="!!dataTableDetails.expandedRow"
  (readStatusChanged)="onChatReadStatusChanged($event)"
  (messageSent)="onChatMessageSent($event)"
  (closed)="closeChat()"
>
</wm-chat-window>

<ng-template #currentActivityTemplate let-row>

  <div
    class="current-activity-cell"
    (click)="$event.stopPropagation()"
  >

@if (row.currentActivities?.length === 1) {
  <a
    href="javascript:void(0)"
    class="current-activity-link"
    (click)="onCurrentActivityClick($event, row.currentActivities[0], row)"
  >
    {{ row.currentActivities[0].activityName  }}
  </a>
} @else if (row.currentActivities?.length > 1) {
  <span
    class="current-activity-link current-activity-menu-trigger"
    [matMenuTriggerFor]="currentActivityMenu"
    #currentActivityTrigger="matMenuTrigger"
    (mouseenter)="openCurrentActivityMenu(row, currentActivityTrigger)"
    (mouseleave)="onCurrentActivityTriggerLeave()"
    [title]="getActivityNames(row.currentActivities)"
  >
    {{ getActivityNames(row.currentActivities) }}
  </span>
}

  </div>

</ng-template>
<mat-menu
  #currentActivityMenu="matMenu"
  class="current-activity-menu"
  xPosition="after"
  yPosition="below"
  [hasBackdrop]="false"
>
  <div
    class="current-activity-menu-content"
    (mouseenter)="onCurrentActivityMenuEnter()"
    (mouseleave)="onCurrentActivityMenuLeave()"
  >
    @for (
      activity of activeCurrentActivities;
      track $index
    ) {
      <button
        mat-menu-item
        class="current-activity-menu-item"
         (click)="onCurrentActivityClick($event, activity, activeCurrentActivityRow)"
      >
        {{ activity.activityName }}
      </button>
    }
  </div>
</mat-menu>
